import conver from 'xml-js'
const host = process.env.REACT_APP_API_URL || 'https://wq.lms-school.ru'
const base = process.env.REACT_APP_BASE || 'kemerovo'
const BASE_API_URL = `${host}/?base=${base}`

const makeRequest = async params => {
  const searchParams = new URLSearchParams()

  for (let a in params) {
    searchParams.append(a, params[a])
  }

  try {
    const response = await fetch(`${BASE_API_URL}&${searchParams.toString()}`)
    if (!response.ok) {
      setTimeout(function () {
        window.location.reload()
      }, 10000);
      return [];
    }

    const text = await response.text()
    const data = conver.xml2js(text, { compact: true }).Answer.Data
    let convertedData = data ? data.Row : []

    if (!Array.isArray(convertedData)) convertedData = [convertedData]
    convertedData.forEach(element => {
      for (let a in element) {
        element[a] = element[a]._text || ''
      }
    })

    return convertedData
  } catch (e) {
    console.log({ error: e })
    return []
  }
}

const getPeriods = async () => await makeRequest({ action: 'eatperiods' })

const getGroups = async () => await makeRequest({ action: 'eatgroups' })

// date should be a string of '2018-11-27' date format
const getMenu = async (eatperiod, date) =>
  await makeRequest({ action: 'kioskmenu', eatperiod, date })

const getCookteam = async () => await makeRequest({ action: 'cookteam' })

const logoImage = `${BASE_API_URL}&action=kiosklogo`

const cookImage = id => `${BASE_API_URL}&action=cookteamphoto&cookteamid=${id}`

const dishImage = id => `${BASE_API_URL}&action=dishphoto&dishid=${id}`

export {
  getPeriods,
  getGroups,
  getMenu,
  getCookteam,
  logoImage,
  cookImage,
  dishImage,
  BASE_API_URL
}
